import { useTranslation } from "react-i18next";

export default function Method() {
  const { t } = useTranslation();
  const steps = t("method.steps", { returnObjects: true });
  const images = [
    "https://images.unsplash.com/photo-1721132537184-5494c01ed87f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3QlMjBkcmF3aW5nJTIwYmx1ZXByaW50JTIwcGxhbnxlbnwwfHx8fDE3ODc3Njk2OTN8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1542621334-a254cf47733d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3QlMjBkcmF3aW5nJTIwYmx1ZXByaW50JTIwcGxhbnxlbnwwfHx8fDE3ODc3Njk2OTN8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1760072513367-55182245e76c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmUlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4Nzc2OTY5M3ww&ixlib=rb-4.1.0&q=85",
  ];
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <div className="eyebrow">Method</div>
      <h1 className="font-serif text-5xl lg:text-6xl mt-6 text-stone-900" data-testid="method-title">{t("method.title")}</h1>
      <p className="mt-6 text-lg text-stone-700 max-w-2xl">{t("method.sub")}</p>

      <div className="mt-20 space-y-24">
        {steps.map((s, i) => (
          <div key={s.t} className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${i % 2 ? "md:[&>div:first-child]:order-2" : ""}`} data-testid={`method-step-${i}`}>
            <div>
              <div className="font-serif text-7xl text-[#D06D4D]">{s.n}</div>
              <h2 className="font-serif text-3xl lg:text-4xl mt-4 text-stone-900">{s.t}</h2>
              <p className="mt-4 text-stone-700 leading-relaxed text-lg">{s.d}</p>
            </div>
            <img src={images[i]} alt="" className="w-full h-[420px] object-cover" />
          </div>
        ))}
      </div>
    </div>
  );
}
